export default __webpack_public_path__ + "static/media/TrackCorona-Screely.5f4633ec.png";